module.exports = __webpack_public_path__ + "static/logo-roch-6eb54d7e020d06a46f6a4e099353748a.svg";